/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Suggest_ThanksInputs */

const en_us2_community_suggest_thanks = /** @type {(inputs: Community_Suggest_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Got it. Thank you for helping decide what comes next.`)
};

const pt_br2_community_suggest_thanks = /** @type {(inputs: Community_Suggest_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recebido. Obrigado por ajudar a decidir o que vem depois.`)
};

const es_419_community_suggest_thanks = /** @type {(inputs: Community_Suggest_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recibido. Gracias por ayudar a decidir lo que viene.`)
};

const pt_pt2_community_suggest_thanks = /** @type {(inputs: Community_Suggest_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recebido. Obrigado por ajudares a decidir o que vem a seguir.`)
};

const fr_fr2_community_suggest_thanks = /** @type {(inputs: Community_Suggest_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bien reçu. Merci de nous aider à décider de la suite.`)
};

const de_de2_community_suggest_thanks = /** @type {(inputs: Community_Suggest_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angekommen. Danke, dass du mitentscheidest, was als Nächstes kommt.`)
};

const it_it2_community_suggest_thanks = /** @type {(inputs: Community_Suggest_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricevuto. Grazie per aiutarci a decidere cosa viene dopo.`)
};

/**
* | output |
* | --- |
* | "Got it. Thank you for helping decide what comes next." |
*
* @param {Community_Suggest_ThanksInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_suggest_thanks = /** @type {((inputs?: Community_Suggest_ThanksInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Suggest_ThanksInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_suggest_thanks(inputs)
	if (locale === "es-419") return es_419_community_suggest_thanks(inputs)
	if (locale === "pt-PT") return pt_pt2_community_suggest_thanks(inputs)
	if (locale === "fr-FR") return fr_fr2_community_suggest_thanks(inputs)
	if (locale === "de-DE") return de_de2_community_suggest_thanks(inputs)
	if (locale === "it-IT") return it_it2_community_suggest_thanks(inputs)
	return en_us2_community_suggest_thanks(inputs)
});
export { community_suggest_thanks as "community.suggest_thanks" }